// extracted by mini-css-extract-plugin
export default {"root":"g6QhFxbseuBHRHSQiitB","placeHolderShimmer":"RZWbuEVfHx1IPwXs42Cg"};